/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
// core components
import Header from "components/Header/Header.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import LogoFooter from "components/Footer/LogoFooter.js";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks0.js";
import SectionDescription from "pages/LandingPage/Sections/SectionDescription.js";
import SectionTeam from "pages/LandingPage/Sections/SectionTeam.js";
import SectionTargets from "pages/LandingPage/Sections/SectionTargets.js"
import SectionOffice from "pages/LandingPage/Sections/SectionOffice.js";
import SectionContact from "pages/LandingPage/Sections/SectionContact.js";
import logo_inv from "assets/img/logo/logopedie_logo_inv.png";

import landingPageStyle from "assets/jss/material-kit-pro-react/pages/landingPageStyle.js";

const useStyles = makeStyles(landingPageStyle);

export default function LandingPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  return (
    <div>
      <Header
        brand="Logopedie | Lieve Mutton"
        links={<HeaderLinks dropdownHoverColor="primary" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 300,
          color: "dark"
        }}
      />
    <Parallax image={require("assets/img/examples/office5.jpg")} filter="dark" small>
        <div className={classes.container}>
          <GridContainer justify="start">
            <GridItem
              md={6}
              sm={6}
              className={classNames(
                classes.mlAuto,
                classes.mrAuto,
              )}
            >
              <img
                src={logo_inv}
                alt="..."
                className={classes.imgRounded + " " + classes.imgFluid}
              />
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <SectionDescription />
        <SectionTeam />
        <SectionTargets/>
        <SectionOffice />
        {/* <SectionContact /> */}
      </div>
      <div className={classes.empty}/>
      <LogoFooter />
    </div>
  );
}
